export function GoogleTranslateWarning() {
  return <p>Warning: Google translate enabled</p>;
}
